import createStore from 'zustand/vanilla';
import createHook from 'zustand';

export const freeTrialStore = createStore((set) => ({
  buttonClicked: false,
  setButtonClicked: (isClicked) =>
    set(() => ({
      buttonClicked: isClicked
    }))
}));

export const setActivateButtonClicked = (isClicked) =>
  freeTrialStore.getState().setButtonClicked(isClicked);

const useFreeTrialStore = createHook(freeTrialStore);

export default useFreeTrialStore;
